var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { testIsMobile } from "@@/Util";
import { action, makeObservable, observable } from "mobx";
export class FloatingNoteDetailsStore {
    constructor() {
        this.topposition = 30;
        this.leftposition = 200;
        this.width = testIsMobile() ? 300 : 350;
        this.height = testIsMobile() ? 250 : 250;
        this.dragging = false;
        this.show = false;
        this.text = "";
        this.editmode = false;
        this.onok = () => { };
        makeObservable(this);
    }
    setContent(content) {
        this.text = content;
    }
    setEditMode(edit) {
        this.editmode = edit;
    }
    setShow(show) {
        this.show = show;
    }
    setDragging(drag) {
        this.dragging = drag;
    }
    setToppos(pos) {
        this.topposition = pos;
    }
    setLeftPos(pos) {
        this.leftposition = pos;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], FloatingNoteDetailsStore.prototype, "topposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FloatingNoteDetailsStore.prototype, "leftposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FloatingNoteDetailsStore.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FloatingNoteDetailsStore.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FloatingNoteDetailsStore.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FloatingNoteDetailsStore.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FloatingNoteDetailsStore.prototype, "text", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], FloatingNoteDetailsStore.prototype, "editmode", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], FloatingNoteDetailsStore.prototype, "setContent", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], FloatingNoteDetailsStore.prototype, "setEditMode", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], FloatingNoteDetailsStore.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], FloatingNoteDetailsStore.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FloatingNoteDetailsStore.prototype, "setToppos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FloatingNoteDetailsStore.prototype, "setLeftPos", null);
